import React from 'react';
import { HabitInsightsCard as HabitInsightsCardBase } from 'shared/components/connected/habit-insights-card';

import { useInsightsTimeframeByTime } from '../../hooks/use-insights-timeframe-by-time';

export type HabitInsightsCardProps = Omit<
  React.ComponentProps<typeof HabitInsightsCardBase>,
  'timeframe' | 'referenceDate'
>;

export const HabitInsightsCard: React.FC<HabitInsightsCardProps> = ({
  habit,
  startDate,
  endDate,
  ...rest
}) => {
  const { referenceDate, timeframe } = useInsightsTimeframeByTime({
    startDate,
    endDate,
  });

  return (
    <HabitInsightsCardBase
      habit={habit}
      startDate={startDate}
      endDate={endDate}
      referenceDate={referenceDate}
      timeframe={timeframe}
      skipLimitsCheck
      {...rest}
    />
  );
};
